"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MaxLines = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const src_1 = require("..");
const react_1 = require("react");
const utils_1 = require("@react-aria/utils");
function MaxLines({ maxLines, children }) {
    const elRef = (0, react_1.useRef)(null);
    const [hasMore, setHasMore] = (0, react_1.useState)(false);
    const [expanded, setExpanded] = (0, react_1.useState)(false);
    // When first rendered it will not be expanded and we'll have the `lineClamp` styles applied.
    // Determine if we need the show more/less buttons.
    // If the content is larger, then we need to set the height of the collapsed content to return to.
    (0, utils_1.useLayoutEffect)(() => {
        if (!elRef.current)
            return;
        // If the content overflows, then set the `hasMore` state to true.
        setHasMore(elRef.current.scrollHeight > elRef.current.clientHeight);
    }, []);
    // Whenever the content changes, reset state
    (0, react_1.useEffect)(() => {
        setExpanded(false);
    }, [children]);
    const onResize = (0, react_1.useCallback)(() => {
        // Listen for changes in the content height and determine if we still need the "show more/less" buttons.
        // This content can change if the user resizes the window, or if the `props.children` change.
        // The tricky part here is that setting `lineClamp` styles also triggers a resize event.
        // We'll need to be aware of when this is triggered from our own `lineClamp` styles, vs externally.
        if (!elRef.current)
            return;
        !expanded && setHasMore(elRef.current.scrollHeight > elRef.current.clientHeight);
    }, [expanded]);
    (0, utils_1.useResizeObserver)({ ref: elRef, onResize });
    return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("div", { ref: elRef, css: src_1.Css.if(!expanded).lineClamp(maxLines).$, children: children }), hasMore && ((0, jsx_runtime_1.jsx)("button", { css: src_1.Css.db.smMd.$, onClick: () => setExpanded((prev) => !prev), children: expanded ? "Show Less" : "Show More" }))] }));
}
exports.MaxLines = MaxLines;
